// Domain constants for Home/Living statuses (DDD)

export type HomeStatusCode =
  | "HOMELESS"
  | "LWF"
  | "LWO"
  | "MJ"
  | "MO"
  | "MS"
  | "REF"
  | "RENT"
  | "RENTS"
  | "UNK";

export const homeStatuses: Record<HomeStatusCode, string> = {
  HOMELESS: "Homeless",
  LWF: "Living With Friends",
  LWO: "Living With Parents",
  MJ: "Mortgage Joint",
  MO: "Mortgage Free (Owner)",
  MS: "Mortgage Sole",
  REF: "Refused",
  RENT: "Rent (Private)",
  RENTS: "Rent (Social)",
  UNK: "Uknown",
};

export type HomeStatus = { code: HomeStatusCode; label: string };

export const homeStatusList: HomeStatus[] = Object.entries(homeStatuses).map(
  ([code, label]) => ({ code: code as HomeStatusCode, label }),
);
